import { Project } from './project'
import { SubVertical } from './verticalService'
import { getDesignerStorePageSize, DesignerStoreTab } from './designer'
import { getFashionBrandStorePageSize, FashionBrandStoreTab } from './fashionBrand'
import { isMobileEnv } from '../utils/common'

export const STORE_PRODUCTS_LIST_SIZE = 10
export const STORE_NEWS_LIST_SIZE = 10
export const STORE_ONE_PRODUCTS_LIST_SIZE = 15

export const getStoreNewsCardSizeInProducts = (subVertical: SubVertical) => {
  if (isMobileEnv) {
    return subVertical === SubVertical.PET ? 2 : 1
  }
  return [SubVertical.PET, SubVertical.HOME_MEAL].includes(subVertical) ? 2 : 3
}

export const getStoreProductPageSize = (subVertical: SubVertical) => {
  if (subVertical === SubVertical.DESIGNER) return getDesignerStorePageSize(DesignerStoreTab.PRODUCT)
  if (subVertical === SubVertical.FASHION_BRAND) return getFashionBrandStorePageSize(FashionBrandStoreTab.PRODUCT)
  return STORE_PRODUCTS_LIST_SIZE
}
